import { create } from 'zustand';
import useOrgStore from './orgStore';
import { clearBoardUnlocks } from '../utils/boardUnlock';

const useAuthStore = create((set, get) => ({
  token: localStorage.getItem('token'),
  user: null,
  _mePollTimer: null,

  login: async (identifier, password, orgId = null) => {
    const body = { identifier, password };
    if (orgId) body.org_id = orgId;
    const res = await fetch('/api/v1/auth/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (!data.success) throw new Error(data.error);
    if (data.data?.needs_org_choice) {
      return { needsOrgChoice: true, orgs: data.data.orgs };
    }
    localStorage.setItem('token', data.data.token);
    set({ token: data.data.token, user: data.data.user });
    return { needsOrgChoice: false };
  },

  fetchMe: async () => {
    const token = localStorage.getItem('token');
    if (!token) return;
    const res = await fetch('/api/v1/auth/me', {
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await res.json();
    if (!data.success) {
      localStorage.removeItem('token');
      set({ token: null, user: null });
      return;
    }
    set({ user: data.data });
  },

  logout: () => {
    const { _mePollTimer } = get();
    if (_mePollTimer) clearInterval(_mePollTimer);
    localStorage.removeItem('token');
    // Quadros desbloqueados nesta aba: a sessao acabou, o desbloqueio acaba
    // com ela. A marca ja e por usuario (utils/boardUnlock.js), entao quem
    // entrar em seguida nao herdaria o desbloqueio nem sem isto — limpar
    // evita deixar marca de sessao encerrada parada no storage.
    clearBoardUnlocks();
    set({ token: null, user: null, _mePollTimer: null });
    useOrgStore.getState().stopOrgPolling?.();
    useOrgStore.getState().clearOrg();
  },

  startMePolling: (intervalMs = 15000) => {
    get().stopMePolling();
    const tick = () => { get().fetchMe().catch(() => {}); };
    const timer = setInterval(tick, intervalMs);
    set({ _mePollTimer: timer });
  },

  stopMePolling: () => {
    const { _mePollTimer } = get();
    if (_mePollTimer) { clearInterval(_mePollTimer); set({ _mePollTimer: null }); }
  },
}));

export default useAuthStore;
